<template id="photos">
    <div class="modal-backdrop modal-full-wrap" id="parkGallery" tabindex="-1" role="dialog" aria-hidden="true" style="overflow:auto;">
        <div class="modal-dialog modal-full" role="document">
            <div class="modal-content photo-gallery-content">
                <div class="modal-header photo-gallery-header blue-gradient position-sticky d-block" style="top:0;z-index:9999;">
                    <ul role="presentation" class="nav nav-pills navbar-dark w-100">
                        <li class="nav-item dropdown cyp-dropdown-filters">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Show: {{ tagName }} </a>
                            <div class="dropdown-menu">
                                <div v-if="from === 'userActivity' || from === 'singleReview'">
                                    <a class="dropdown-item cyp-filter-item" @click="tagFilter(photos.tags[tag].name)" v-for="tag in Object.keys(photos.tags)">{{ photos.tags[tag].name }} <span class="photo-count">(<span class="cyp-photo-count">{{ photos.tags[tag].photos.length }}</span>)</span></a>
                                </div>
                                <div v-else>
                                    <a class="dropdown-item cyp-filter-item" @click="tagFilter(tag)" v-for="tag in Object.keys(photos.tags)"> {{ tag }} <span class="photo-count">(<span class="cyp-photo-count">{{ photos.tags[tag].length }}</span>)</span></a>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item ml-auto">
                            <button type="button" class="btn btn-close" aria-label="Close" @click="close">
                                <span aria-hidden="true">
                                    <svg-icon class="svg-24" icon="ic-close"></svg-icon>
                                </span>
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="modal-body p-0 container-fluid">
                    <div class="row row-pd align-items-stretch">
                        <div class="media-main col-12 col-sm-9 col-lg-8 h-100">
                            <div class="py-2">
                                    <ul class="Photos">
                                        <photo v-for="photo in filteredPhotos" :photo="photo" :startphoto="startphoto" v-bind:key="photo.id">
                                        </photo>
                                    </ul>
                            </div>
                        </div>
                        <aside class="media-aside col-12 col-sm-3 col-lg-4">
                            <div class="p-1 p-sm-3">
                                <div class="img-park-info">
                                    <a v-bind:href="park.url">{{ park.name }}</a><br>
                                    <a v-bind:href="park.city.url" class="city-name small">{{ park.city.name }}, {{ park.region.abbr }}</a><br><br>
                                </div>
                                <div v-if="showAddPhotoButton">
                                    <a href="#" class="btn btn-primary btn-xl" @click="parentModalShow()" v-if="user !== null">Add Photos</a>
                                    <a href="/account/signIn" class="btn btn-primary btn-xl" v-else>Add Photos</a>
                                </div>
                                <br>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Photo from "./Photo.vue";

    export default {
        props: ['photos', 'defaulttag', 'startphoto', 'startpark', 'from'],
        name: "photos",
        data() {
            return {
                user: this.$parent.user,
                park: this.$parent.park === undefined ? this.$props.startpark : this.$parent.park,
                tagName: this.$props.defaulttag === '' ? 'All Photos' : this.$props.defaulttag,
                filteredPhotos: []
            }
        },

        computed: {
            fromReviewFeed() {
                if (this.$parent.onlyDisplayPhotoIds === undefined) {
                    return false;
                }

                return this.$parent.onlyDisplayPhotoIds !== null && this.$parent.onlyDisplayPhotoIds.length > 0;
            },
            showAddPhotoButton() {
                return this.from !== 'userActivity' && this.from !== 'singleReview' && !this.fromReviewFeed;
            }
        },

        components: {
            Photo
        },

        created() {
            this.$store.commit("writePhotos", this.$props.photosToList);
        },

        mounted() {
            this.tagFilter(this.tagName);
        },

        methods:{
            parentModalShow()
            {
                this.toggleBodyClass('addClass', 'modal-open');
                this.$parent.showModal = true;
            },
            close ()
            {
                this.toggleBodyClass('removeClass', 'modal-open');
                this.$parent.showPhotos = false;
                this.$parent.onlyDisplayPhotoIds = null;
            },
            doPhotoArrangment ()
            {
                this.$parent.flushList();
                this.$parent.photosToList = [];
                this.$parent.photosToList.push(this.filteredPhotos);
                this.$store.commit("writePhotos", this.filteredPhotos);
            },
            tagFilter(tagName) {
                this.tagName = tagName;
                this.filteredPhotos = [];

                for(let tag of Object.keys(this.$props.photos.tags)) {
                    if(this.$props.from == 'userActivity' || this.$props.from == 'singleReview'){
                        if(this.$props.photos.tags[tag].name == this.tagName) {
                            this.filteredPhotos = this.$props.photos.tags[tag].photos;
                        }
                    }
                    else{
                        if(tag == this.tagName) {
                            this.filteredPhotos = this.$props.photos.tags[tag];
                        }
                    }
                }

                let onlyDisplayPhotoIds = this.$parent.onlyDisplayPhotoIds;
                if (onlyDisplayPhotoIds) {
                    this.filteredPhotos = this.filteredPhotos.filter(photo => onlyDisplayPhotoIds.includes(photo.id));
                }

                this.doPhotoArrangment();

            }
        }
    }
</script>

<style scoped lang="scss">
@import "../../sass/web/variables.scss";

.Photos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}
.nav-item.dropdown > a.nav-link {
    background: $red-600;
    font-weight: 700;
    span.photo-count {
        font-weight: 400;
    }
}
</style>
